import React, { useState } from 'react'
import {
  IconHide,
  IconShow,
  TextField,
  TextFieldButton,
} from 'src/viewLayer/components/DesignSystem'
import { t } from 'src/viewLayer/helpers/translations'

export default ({
  disabled,
  errorKey,
  id,
  isFocused,
  label,
  onChangeHandler,
  placeholder,
  value,
}) => {
  const [visible, setVisible] = useState(false)

  return (
    <TextField
      actionButton={
        value ? (
          <TextFieldButton
            icon={visible ? <IconShow /> : <IconHide />}
            onClick={() => setVisible((previous) => !previous)}
            title={visible ? 'Hide' : 'Show'}
          />
        ) : null
      }
      additionalText={errorKey && t(errorKey)}
      ariaDescribedby={id ? `message-${id}` : 'message-uat-password-input-field'}
      autoComplete="new-password"
      autoFocus={isFocused}
      color="lightened"
      disabled={disabled}
      fullWidth
      id={id || 'uat-password-input-field'}
      label={label}
      onChange={onChangeHandler}
      placeholder={placeholder || t('password.placeholder')}
      state={errorKey ? 'error' : 'default'}
      type={visible ? 'text' : 'password'}
      value={value}
    />
  )
}
